<template>
  <div class="dict">
    <div class="addCooperation">
      <!-- tab页 -->
      <el-tabs class="addCooperationTabs" type="border-card">
        <!-- 仓储信息 -->
        <el-tab-pane :label="this.$t('warehouseContract.form.warehouseInfo')">
          <el-form :model="formData" ref="formData" label-width="90px">
            <el-collapse v-model="activeNames" class="collapse-main-content">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="collapse-title-pre">
                    <span></span>{{ this.$t('warehouseContract.form.basicInfo') }}
                  </div>
                </template>
                <div class="collapse-content">
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractEnterpriseNo"
                        :label="this.$t('warehouseContract.form.contractEnterpriseNo')"
                      >
                        <el-input v-model="formData.contractEnterpriseName" :disabled="true" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="registeredAssets"
                        :label="this.$t('warehouseContract.form.registeredAssets')"
                      >
                        <el-input
                          v-model="formData.registeredAssets"
                          :disabled="canNotEdit"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contactPersonNo"
                        :label="this.$t('warehouseContract.form.contactPersonNo')"
                      >
                        <el-input
                          v-model="formData.contactPersonNo"
                          :disabled="canNotEdit"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contactPhone"
                        :label="this.$t('warehouseContract.form.contactPhone')"
                      >
                        <el-input
                          v-model="formData.contactPhone"
                          :disabled="canNotEdit"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="signDate"
                        :label="this.$t('warehouseContract.form.signDate')"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="formData.signDate"
                          :disabled="canNotEdit"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          clearable
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="valideDateTo"
                        :label="this.$t('warehouseContract.form.valideDateTo')"
                      >
                        <el-date-picker
                          style="width: 100%"
                          v-model="formData.valideDateTo"
                          :disabled="canNotEdit"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          clearable
                        >
                        </el-date-picker>
                        <!-- <el-input v-model="formData.valideDateTo"  :disabled="canNotEdit"
                                                :placeholder='this.$t("warehouseContract.form.valideDateToPlaceholder")'>
                                            </el-input> -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="goodsControlAmount"
                        :label="this.$t('warehouseContract.form.goodsControlAmount')"
                      >
                        <el-input
                          v-model="formData.goodsControlAmount"
                          :disabled="canNotEdit"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="productCategory"
                        :label="this.$t('warehouseContract.form.productCategory')"
                      >
                        <el-input
                          v-model="formData.productCategory"
                          :disabled="canNotEdit"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="feature"
                        :label="this.$t('warehouseContract.form.feature')"
                      >
                        <el-input
                          v-model="formData.feature"
                          :disabled="canNotEdit"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractVenue"
                        :label="this.$t('warehouseContract.form.contractVenue')"
                      >
                        <el-input
                          v-model="formData.contractVenue"
                          :disabled="canNotEdit"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="chargeStandard"
                        :label="this.$t('warehouseContract.form.chargeStandard')"
                      >
                        <el-input
                          v-model="formData.chargeStandard"
                          :disabled="canNotEdit"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">
                  <div class="collapse-title-pre">
                    <span></span>{{ this.$t('warehouseContract.form.systemInfo') }}
                  </div>
                </template>
                <div class="collapse-content">
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractCompanyName"
                        :label="this.$t('warehouseContract.form.contractCompanyNo')"
                      >
                        <el-input
                          v-model="formData.contractCompanyName"
                          :disabled="true"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractCreatePersonName"
                        :label="this.$t('warehouseContract.form.contractCreatePersonNo')"
                      >
                        <el-input
                          v-model="formData.contractCreatePersonName"
                          :disabled="true"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6">
                      <el-form-item
                        prop="contractCreateDate"
                        :label="this.$t('warehouseContract.form.contractCreateDate')"
                      >
                        <el-input
                          v-model="formData.contractCreateDate"
                          :disabled="true"
                          clearable
                          maxlength="32"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        prop="contractMark"
                        :label="this.$t('warehouseContract.form.contractMark')"
                      >
                        <el-input
                          v-model="formData.contractMark"
                          :disabled="canNotEdit"
                          clearable
                          maxlength="126"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-form>
        </el-tab-pane>
        <!-- 附件信息 -->
        <el-tab-pane :label="this.$t('warehouseContract.form.attachmentInfo')">
          <upload ref="upload" v-bind:tableData="attachmentList" v-bind:isShow="false" />
        </el-tab-pane>
        <!-- 历史记录 -->
        <el-tab-pane :label="this.$t('warehouseContract.form.history')">
          <div class="gird">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="xGridHistory"
              class="vxe-table-element"
              size="mini"
              align="left"
              :auto-resize="true"
              :data="historyData"
            >
              <vxe-table-column type="checkbox" width="60"></vxe-table-column>
              <vxe-table-column
                type="index"
                width="60"
                :title="$t('table.index')"
              ></vxe-table-column>
              <vxe-table-column field="gmtCreate" :title="$t('warehouseContract.form.gmtCreate')" />
              <vxe-table-column
                field="updateContent"
                :title="$t('warehouseContract.form.updateContent')"
              />
            </vxe-grid>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="fixed-bottom-btnList">
      <el-button
        v-if="
          formData.contractStatus == 'ZT06' ||
          formData.contractStatus == 'ZT05' ||
          formData.contractStatus == 'ZT03'
        "
        type="primary"
        @click="gotoEdit"
        v-hasPermi="['2021050814415119145']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.edit') }}</el-button
      >
      <el-button
        v-if="formData.contractStatus == 'ZT03'"
        type="primary"
        @click="disable"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.disable') }}</el-button
      >
      <el-button
        v-if="formData.contractStatus == 'ZT04' && userInfo.userInfo.adminFlag == 1"
        type="primary"
        @click="del('ZT03')"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.inable') }}</el-button
      >
      <el-button
        v-if="
          formData.contractStatus == 'ZT06' ||
          (formData.contractStatus == 'ZT05' && userInfo.userInfo.adminFlag == 1)
        "
        type="danger"
        @click="del('')"
        v-hasPermi="['2021050814420005396']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <el-button
        v-if="formData.contractStatus == 'ZT05'"
        type="primary"
        @click="quit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.quit') }}</el-button
      >
    </div>
    <DisabledReson ref="disabledReson" v-on:getData="getData" />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchModal from '@/components/SearchModal';
  import API from '@/api/logisticsCenter/warehouseContract.js';
  // import DataBaseAPI from '@/api/dataBase';
  import upload from '@/components/upload';
  // import formRules from './rules/rules';
  import DisabledReson from './components/disabledReson';
  export default {
    components: {
      // SearchModal,
      upload,
      DisabledReson,
    },
    name: 'logisticsContractDetail',
    data() {
      // let newDate = new Date();
      // let date = newDate.getFullYear() + '-' + newDate.getMonth() + '-' + newDate.getDate();
      let canNotEdit = this.$route.query.canNotEdit == '0' ? true : false;
      return {
        contractType: '02',
        historyData: [],
        contractNo: null,
        canNotEdit: true,
        isEdit: !canNotEdit,
        load: false,
        attachmentList: [], //附件列表
        activeNames: ['1', '2', '3', '4', '5', '6', '7'], //默认展开那些面板，
        formData: {},
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    mounted() {
      this.contractNo = this.$route.query.contractNo || null;
      if (this.contractNo) {
        this.getData();
      }
    },
    methods: {
      //获取详情
      getData() {
        let params = {
          contractType: this.contractType,
          contractNo: this.contractNo,
        };
        this.$axios.get(API.DETAIL_CONTRACT__API, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.formData = res.data.data;
            this.attachmentList = res.data.data.distributionAttachments;
            this.warehouseData = res.data.data.distributionContractStorages;
            this.goodsData = res.data.data.distributionContractProducts;
            this.historyData = res.data.data.dataHistories;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //跳转到编辑页面
      gotoEdit() {
        let path = {
          path: '/logistics/logisticsContractEdit',
          name: 'logisticsContractEdit',
          meta: {
            keepAlive: true,
          },
          query: {
            version: this.formData.version,
            contractNo: this.formData.contractNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //禁用
      disable() {
        this.$refs.disabledReson.openDialog(true, this.formData, '02');
      },
      //删除/启用/禁用
      del(type) {
        let msg = '';
        let content = '';
        if (type == 'ZT04') {
          msg = this.$t('confirm.forbid');
          content = this.$t('confirm.forbidContent');
        } else if (type == 'ZT03') {
          msg = this.$t('confirm.lift');
          content = this.$t('confirm.liftContent');
        } else {
          msg = this.$t('confirm.delete');
          content = this.$t('confirm.content');
        }
        this.$confirmAction(msg, content)
          .then(() => {
            let params = {
              admin: this.userInfo.userInfo.adminFlag,
              contractType: this.contractType,
              version: this.formData.version,
              contractNo: this.formData.contractNo,
              contractUpdatePersonName: this.userInfo.userInfo.userName,
            };
            if (type) {
              params.contractStatus = type;
            }
            this.$axios.post(API.DELETE_CONTRACT_API, params).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                //this.getData()
                this.gotoList();
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //放弃
      quit() {
        this.$confirmAction(this.$t('confirm.remove'), this.$t('confirm.removeContent'))
          .then(() => {
            let params = {
              contractType: this.contractType,
              version: this.formData.version,
              contractNo: this.formData.contractNo,
              contractUpdatePersonName: this.userInfo.userInfo.userName,
            };
            this.$axios.post(API.QUIT_CONTRACT_API, params).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                //this.getData()
                this.gotoList();
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      gotoList() {
        let detailName = '';
        let listName = '';
        if (this.contractType == '01') {
          detailName = 'wareHouseContractDetail';
          listName = 'wareHouseContractList';
        } else if (this.contractType == '02') {
          detailName = 'logisticsContractDetail';
          listName = 'logisticsContractList';
        } else if (this.contractType == '03') {
          detailName = 'wharfOperationContractDetail';
          listName = 'wharfOperationContractList';
        } else {
          detailName = 'transportContractDetail';
          listName = 'transportContractList';
        }
        let path = {
          fromPath: {
            path: '/logistics/' + detailName,
            name: detailName,
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/logistics/' + listName,
            name: listName,
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
